<template>
  <div>
    <p class="title-table">Deseja adicionar tabela de frete?</p>
    <div class="flat-switch">
      <sc-switch 
        class="switch-add" 
        @input="addFreightTable"
        />
        {{ includeFreightTable ? 'Sim' : 'Não' }}
    </div>
    <sc-freight-form 
      v-if="includeFreightTable"
      v-model="lpData"
      :checkFields="checkFields"/>
    <help-button/>
  </div>
</template>

<script>
  import { createNamespacedHelpers } from 'vuex';
  import {
    ScSwitch,
  } from '@intelipost-js/secure-components';

  import HelpButton from './base/HelpButton.vue';
  import ScFreightForm from './freight/ScFreightForm.vue';

  const { mapState, mapActions, mapMutations } = createNamespacedHelpers(
    'integrations/integrationsAppSelfService',
  );

  export default {
    name: 'sc-freight-table',

    data() {
      return {
        lpData: {
          warehouses: [],
          quote_table: {
            quote_table_additional_info: '',
            quote_table_type: 'Padrão Transportadora - Validação comercial + 8 dias úteis para implantação',
            additional_table_type: 'NONE',
            vtex_origin_zip_code: '',
            linx_type: '',
            origin_type: 'UNIQUE_WAREHOUSE',
            warehouse_initial_zip_code: '',
            warehouse_final_zip_code: '',
            client_ids_to_replicate: '',
            quote_table_files: [],
            inteli_envios_lp: [],
            inteli_envios_lp_formatted: '',
          },
        },
        includeFreightTable: false,
        checkFields: false,
      };
    },
    computed: {
      ...mapState([
        'clientInfo',
        'appDetails',
        'contact',
      ]),
    },
    methods: {
      ...mapMutations(['setLoading']),
      ...mapActions([
        'getClientInfo',
        'createNewLpRequestTickets',
      ]),

      addFreightTable() {
        this.includeFreightTable = !this.includeFreightTable;
      },
      validate() {
        const fieldsToValidate = [
          'client_name',
          'client_phone_number',
          'client_email',
          'warehouses',
          'has_contract',
          'contract_number',
          'client_consent'];

        this.checkFields = true;
        for (const field of fieldsToValidate) {
          if (!this.lpData[field] && this.includeFreightTable) {
            return false;
          }
        }
        return true;
      },
      async createTickets() {
        const formattedInteliEnviosLp = this.lpData.quote_table.inteli_envios_lp.toString();

        this.lpData.quote_table.inteli_envios_lp_formatted = formattedInteliEnviosLp;
  
        this.lpData.should_integrate_lp = 'Não';
  

        if (this.lpData.client_consent === 'Sim') {
          this.lpData.client_consent_sentence = '-Confirmo que essa integração está acordada e com contrato finalizado com o transportador escolhido.';
        }
  
        const quoteTable = { ...this.lpData.quote_table };
        const attachments = quoteTable.quote_table_files;
        delete quoteTable.quote_table_files;

        this.setLoading(true);

        const args = {
          lp_data: {
            ...this.lpData,
            company_name: this.clientInfo.common_name,
            client_id: this.clientInfo.id.toString(),
            logistic_provider: this.appDetails.app_name,
            lp_contact_name: this.contact.logistic_provider_contact_name,
            lp_contact_phone_number: this.contact.logistic_provider_contact_phone_number,
            lp_contact_email: this.contact.logistic_provider_contact_email,
            warehouses: this.lpData.warehouses.join(','),
          },
          quote_table: quoteTable,
          attachments,
        };

        await this.createNewLpRequestTickets(args);
        this.setLoading(false);
      },
    },
    components: {
      ScSwitch,
      HelpButton,
      ScFreightForm,
    },
  };

</script>
<style lang="scss">
  @import "~@intelipost-js/secure-ui/src/scss/variables";

  $error: #e84c3d;
  $primary-form: #3670d6;

  .detail-logistic-provider {
    color: gray;
    font-size: 0.9rem;
  }
  .required {
    color: $error;
  }
  .title-table {
    font-size: 18px;
    font-weight: 700;
    color: #010906;
    margin-bottom: 10px;
  }
  .title-company {
    font-size: 16px;
    font-style: normal;
    font-weight: 700;
    line-height: 24px;
    letter-spacing: 0.16px;
    color: #010906;
    margin-top: 10px;
    margin-bottom: 10px;
  }
  .field-company label{
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: 20px;
    letter-spacing: 0.14px;
    color: #39554A;
  }
  .term {
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: 24px;
    letter-spacing: 0.16px; 
    color: $primary;
  }
  .term-align {
    margin-top: 10px;
  }
  .term-text {
    color: $primary-form;
  }
  .b-checkbox.checkbox.term-check
    input[type=checkbox]:checked+.check {
      background-color: $link;
      border-color: $link;
  }
  .description-table {
    font-size: 16px;
    margin-bottom: 18px;
  }
</style>
  
  



// WEBPACK FOOTER //
// node_modules/@intelipost-modules/secure-integrations/features/integrations-app-self-service/components/ScFreightTable.vue